import { core } from '@tock/coretypes';
import { useFeatureFlag } from '@tock/shared/utils/featureFlagContext';

/**
 * Checks for flag being enabled or not for Tock.
 * @example
 * const isEnabled = useFeatureFlagForConsumer('GIFT_CARD');
 */
export function useFeatureFlagForConsumer(flagName: core.Feature.FeatureName): boolean {
  const flagStatus = useFeatureFlag(flagName);

  return flagStatus;
}

export function useConsumerFeatureFlag(flagName: core.Feature.FeatureName): boolean {
  return useFeatureFlagForConsumer(flagName);
}
